//#region src/modules/ServicePeriods/activity-evals/format-minutes.ts
function formatCompactMinutes(minutes) {
	if (minutes < 60) return `${minutes}m`;
	const hours = Math.floor(minutes / 60);
	const remainder = minutes % 60;
	if (remainder === 0) return `${hours}h`;
	return `${hours}h ${remainder}m`;
}
function formatMinutes(minutes) {
	if (minutes < 60) return `${minutes} min`;
	const hours = Math.floor(minutes / 60);
	const remainder = minutes % 60;
	const hourLabel = hours === 1 ? "1 hr" : `${hours} hr`;
	if (remainder === 0) return hourLabel;
	return `${hourLabel} ${remainder} min`;
}
//#endregion
export { formatCompactMinutes, formatMinutes };

//# sourceMappingURL=format-minutes.js.map